__turbopack_context__.v({
  "container": "PartnersTypeform-module__n-3Dea__container",
});
